export const LANDING_BAR_HEIGHT_MOBILE = 55;
export const LANDING_BAR_HEIGHT = 96;
